














import { Component, Vue, Prop, Emit } from "vue-property-decorator";

@Component({
  name: "One",
})
export default class One extends Vue {
  @Prop({
    type: Array,
    default: [],
  })
  content!: Array<any>;

  @Prop({
    type: [String,Number],
    default: '',
  })
  id!: String;

  @Emit()
  public imageClick(item: any) {
    return item;
  }

  created() {
    // console.log("data==1==>", this.content);
  }
}
